'use strict';

import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import TextInput from 'Components/Forms/Elements/TextInput';
import Loader from 'Pure/Loader';
const {
  app,
  qwest
} = window;
export default class PasswordRecoveryForm extends Component {
  state = {
    status_messages: {}
  };
  handleChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    component.setState({
      [name]: value,
      error: undefined,
      status_messages: status_messages
    });
  };
  requestPassword = e => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/user/recover-password', {
      login: state.login
    }).then(function (xhr, response) {
      component.setState({
        info: 'un email comportant un lien pour créer votre ' + 'nouveau mot de passe vous a été envoyé par e-mail.'
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const message = getFormStatus(state);
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let submit;
    if (!state.info) {
      submit = /*#__PURE__*/React.createElement("div", {
        className: "u-full-width u-margin-top-25\r u-padding-bottom-20 u-text-center"
      }, /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: component.requestPassword
      }, "Valider", loader));
    }
    let output = /*#__PURE__*/React.createElement("div", {
      className: "u-text-center"
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['login'],
      name: "login",
      label: "E-mail de connexion",
      status: state.status_messages
    }), message, submit);
    return output;
  }
}
